import React from 'react'
import '../index.css';
import Card from './Card';
import Discord from '../Images/Discord.png'
import Android from '../Images/Android.png'
import PythonLogo from '../Images/Python.png'
import ReactLogo from '../Images/React.png'
import Drawing from '../Images/Drawing.png'
import Tailwind from '../Images/Tailwind.png'
import FormSubmit from '../Images/FormSubmit.webp'
import Pokeball from '../Images/Pokeball.png'
import Steam from '../Images/Steam.png'
import PyTorchLogo from '../Images/pytorch-logo.png'
import HuggingFace from '../Images/HuggingFace.png'
import PandasLogo from '../Images/Pandas.png'


function Skills() {
  const projects = [
    {
      title: 'Discord ML Bot',
      description: "Developed a Discord Chatbot that implements and additionally trains HuggingFace's Seq2Seq Transformer Models, using Python and PyTorch, to generate response messages to Discord users. ",
      imageUrl: Discord,
      language1: PythonLogo,
      language2: PyTorchLogo,
      language3: HuggingFace,
    },
    {
      title: 'QR-Quest',
      description: 'Collaboratively developed a QR-Code scanning game with a group of 5 other members, using Java, Firebase, JUnit in Android Studio, implementing CameraX and Google Maps API, where players would be able to compete to scan the most valuable QR Codes in their region(s).',
      imageUrl: Android,
      language1: 'https://upload.wikimedia.org/wikipedia/en/thumb/3/30/Java_programming_language_logo.svg/1200px-Java_programming_language_logo.svg.png',
      language2: 'https://miro.medium.com/v2/resize:fit:300/1*R4c8lHBHuH5qyqOtZb3h-w.png',
      language3: 'https://1.bp.blogspot.com/-LgTa-xDiknI/X4EflN56boI/AAAAAAAAPuk/24YyKnqiGkwRS9-_9suPKkfsAwO4wHYEgCLcBGAsYHQ/s0/image9.png',
      githubLink: 'https://github.com/CMPUT301W23T33/QR-Quest'
    },
    {
      title: 'Portfolio Website',
      description: 'This portfolio website that you are currently viewing, was built using React, TailwindCSS, and FormSubmit for the Contact Form.',
      imageUrl: Drawing,
      language1: ReactLogo,
      language2: Tailwind,
      language3: FormSubmit,
    },
    {
      title: "Who's That Pokemon?",
      description: "Developed a Who's That Pokemon web game with React, Javascript, HTML, CSS and Bootstrap, implementing PokeAPI. Includes all Pokemon up to Gen 7.",
      imageUrl: Pokeball,
      language1: ReactLogo,
      language2: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/1200px-Bootstrap_logo.svg.png',
      language3: 'https://pipedream.com/s.v0/app_mvNhzR/logo/orig',
      githubLink: 'https://github.com/abinandn1/whosthatpokemon'
      
    },
    {
      title: 'Steam Top Sellers',
      description: 'Built a web scraping application that displays top Steam games based on genres, using Python, Pandas, BeautifulSoup and Streamlit.',
      imageUrl: Steam,
      language1: PythonLogo,
      language2: PandasLogo,
      language3: 'https://images.datacamp.com/image/upload/v1640050215/image27_frqkzv.png',
      githubLink:'https://github.com/abinandn1/steamwebscraping'
    },

  ];
return (
  <div className>
    <main className={`container mx-auto px-4 py-6 ${'fade-in'}`}>
      <h2 className="text-4xl font-semibold text-indigo-600 mb-4 animate-fade-in-up mb-10 underline">Skills</h2>
      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((project, index) => (
            <Card
              key={index}
              title={project.title}
              description={project.description}
              imageUrl={project.imageUrl}
              language1={project.language1}
              language2={project.language2}
              language3={project.language3}
              githubLink={project.githubLink}
            />
          ))}
        </section>
    </main>
  </div>
  
)
}



export default Skills